<template>
  <v-row align="center" justify="center">
    <v-card :loading="isLoading" :disabled="isLoading || isAuthenticated">
      <v-tabs hide-slider fixed-tabs>
        <v-tab v-text="$t('sign_in')" :to="{ name: 'signin' }"></v-tab>
        <v-tab v-text="$t('sign_up')" :to="{ name: 'signup' }"></v-tab>
        <v-tab v-text="$t('recover')" :to="{ name: 'recover' }" v-if="$route.name == 'recover'"></v-tab>
        <v-tab v-text="$t('resend')" :to="{ name: 'resend' }" v-if="$route.name == 'resend'"></v-tab>
        <v-tab v-text="$t('reset')" :to="{ name: 'reset' }" v-if="$route.name == 'reset'"></v-tab>
      </v-tabs>

      <v-card-text style="width:35vw">
        <!-- <keep-alive>
          <router-view></router-view>
        </keep-alive> -->
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'isLoading'])
  }
}
</script>
